import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-5" }
const _hoisted_3 = { class: "d-flex flex-wrap gap-2 justify-content-md-end mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"col-md-7\"><div class=\"mb-4\"><h3 class=\"fs-20 fw-semibold mb-1\"> Welcome Back, <span class=\"text-primary\">Olivia!</span></h3><p style=\"line-height:1.4;\"> Monitor and manage employee performance, attendance and more in one place. </p></div></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_RouterLink, {
          to: "/extra-pages/pricing-plan",
          class: "btn d-flex align-items-center gap-1",
          style: {"background-color":"#f3e8ff","color":"#7c24cc","padding":"3.5px 11px"}
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createElementVNode("i", {
              class: "ri-vip-crown-line fs-18 lh-1",
              style: {"color":"#7c24cc"}
            }, null, -1),
            _createElementVNode("span", null, "Plan Upgrade", -1)
          ]))]),
          _: 1
        }),
        _cache[1] || (_cache[1] = _createElementVNode("button", {
          class: "btn d-flex align-items-center gap-1",
          style: {"background-color":"#ffe8d4","color":"#c52b09","padding":"3.5px 11px"}
        }, [
          _createElementVNode("i", {
            class: "ri-file-download-line fs-18 lh-1 position-relative top-1",
            style: {"color":"#c52b09"}
          }),
          _createElementVNode("span", null, "Export Reports")
        ], -1))
      ])
    ])
  ]))
}